import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2, ViewChild
} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {Subscription} from "rxjs";

import {Saseung3} from "../../models/saseung3.model";
import {getContentSize} from "../../defines/client.func";
import {GetFourTonesArray} from '../../defines/gukeo.func';
import {clickOutsideLinkMixin} from "../../mixin/click-outside.mixin";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {Saseung3HanjaService} from "../../services/saseung3-hanja/saseung3-hanja.service";

const MAX_HANJA_ITEM = 3;


@Component({
  selector: 'app-word-hanja-popup',
  templateUrl: './word-hanja-popup.component.html',
  styleUrls: ['./word-hanja-popup.component.scss']
})
export class WordHanjaPopupComponent extends clickOutsideLinkMixin implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('popupContainer') popupContainer?: ElementRef;
  @Input() hanja?: string
  @Output() close = new EventEmitter<string | null>();
  @Output() viewInit = new EventEmitter<HTMLElement>();

  protected readonly GetFourTonesArray = GetFourTonesArray;

  protected popupTop: number = 0;

  // 화면에 표시되는 한자. 글자가 2개 이상일 수도 있다.
  protected hanjas?: string;

  public errorTxt: string | null = null;

  private load$: Subscription | null = null;
  listSaseung3: Array<Saseung3> | null = null
  private totalSaseungCount = 0;

  protected get IsLoading(): boolean {
    return this.load$ !== null && !this.errorTxt;
  }

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
    private saseung3HanjaSvc: Saseung3HanjaService,
  ) {
    super(elementRef, renderer, globalEventSvc);
  }

  ngOnInit() {
    // mixin을 이용해서 팝업창 외부를 클릭했는지 체크한다.
    this.coInit(() => this.close.emit(null));

    if (this.hanja) {
      this.saseung3HanjaSvc.ResetList({hanja: this.hanja});
      this.load$ = this.saseung3HanjaSvc.GetNextList().subscribe({
        next: () => {
          const list = this.saseung3HanjaSvc.getList();
          this.totalSaseungCount = this.saseung3HanjaSvc.getTotalCount() ?? 0;
          this.listSaseung3 = list?.slice(0, MAX_HANJA_ITEM) ?? null;
          this.hanjas = list?.[0]?.hanja ?? undefined;
          console.warn('WordHanjaPopupComponent.ngOnInit: loaded', this.listSaseung3);
        },
        error: (error: unknown) => {
          this.load$ = null;  // 에러 시에도 로딩 상태 해제
          if (error instanceof HttpErrorResponse && error.status === 404) {
            this.errorTxt = '문자 정보를 찾을 수 없습니다.';
          } else {
            console.error('WordHanjaPopupComponent.ngOnInit: error', error);
            this.errorTxt = '정보를 불러오는 중 오류가 발생했습니다.';
          }
        },
        complete: () => {
          this.load$ = null;
        }
      });
    }
  }

  ngAfterViewInit() {
    this.viewInit.emit(this.elementRef.nativeElement.firstChild);

    // position이 설정된 부모 요소 찾기
    const positionedParent = this.elementRef.nativeElement.offsetParent;
    // console.warn(positionedParent);

    const {height} = getContentSize(positionedParent);
    const popupTop = height + 5;
    // console.warn(popupTop, positionedParent, this.popupContainer?.nativeElement);

    this.popupTop = popupTop;
  }

  ngOnDestroy() {
    // 기존 mixin 정리
    this.coDestroy();
    
    // 구독 해제 처리
    if (this.load$) {
      this.load$.unsubscribe();
      this.load$ = null;
    }
  }

  protected getMoreTxt(): string | null {
    let moreTxt: string | null = null;
    const moreCount = this.totalSaseungCount - (this.listSaseung3?.length ?? 0);
    moreTxt = moreCount ? `${moreCount}개의 문자가 더 있습니다.` : null;
    return moreTxt;
  }

  /**
   * 상위 요소로 이벤트 전파를 막는다.
   * @param event
   */
  onVoid(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);
  }

  onCloseMore($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(this.hanja);
  }

  onClose($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(null);
  }

  protected getHanjaChars(hanja: string): string[] {
    return Array.from(hanja);
  }

  /**
   * 첫 번째 훈 추출 (saseung3-item과 동일한 로직)
   */
  protected getFirstHun(saseung: Saseung3): string {
    if (!saseung.meaning) return '';
    return saseung.meaning.split('|')[0] ?? '';
  }

  /**
   * 나머지 훈들을 중간점으로 구분하여 반환
   */
  protected getRestHun(saseung: Saseung3): string {
    if (!saseung.meaning) return '';
    const rest = saseung.meaning.split('|').slice(1);
    return rest.length > 0 ? rest.join(' · ') : '';
  }
}
